import React from "react";
import './HomeStats.css';

export default React.memo(function HomeStats() {
    const data = [
        { stats: '7%', text: 'Profit Targets' },
        { stats: '$2M+', text: 'Paid out to Funded Traders' },
        { stats: '170+', text: 'Countries We Trade With' },
        { stats: '13,000+', text: 'Active Traders' }
    ];

    return (
        <div className="homestats__container">
            <div className="homestats__innercontainer">
                {data.map((item, index) => (
                    <div className="homestats__item" key={index}>
                        {index !== 0 && <div style={{ position: 'absolute', width: 1, height: '100%', backgroundColor: '#797979' }}></div>}
                        <div className="homestats__itemstat">
                            <p>{item.stats}</p>
                        </div>
                        <div className="homestats__itemsp">
                            {item.text}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
});
